"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  background: '#1E1E1E',
  brace: '#DCDCDC',
  keyQuotes: '#9CDCFE',
  valueQuotes: '#D69D85',
  colon: '#DCDCDC',
  comma: '#DCDCDC',
  key: '#9CDCFE',
  value: {
    string: '#D69D85',
    null: '#569CD6',
    number: '#B8D7A3',
    boolean: '#569CD6'
  },
  bracket: '#DCDCDC'
};
exports.default = _default;